var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.791992H513V342.792H0V0.791992Z",
    fill: "#DA1A35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.726 0.791992L102.4 342.118H0V0.791992H443.726Z",
    fill: "#009543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.124 0.791992L158.798 342.118H11.876L353.202 0.791992H500.124Z",
    fill: "#FBDE4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.793945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCg);
export default __webpack_public_path__ + "static/media/CG.c7902621919e7c177380d148156b0cd5.svg";
export { ForwardRef as ReactComponent };